import { useMemo } from "react";
export var useSearchActions = function (dispatch, onSearchAction) {
    return useMemo(function () { return ({
        setCriteria: function (criteria, options) { return dispatch({ type: "SET_CRITERIA", payload: { criteria: criteria, options: options } }); },
        updateCriteria: function (criteria, options) {
            var _a, _b;
            var payload = (_b = (_a = onSearchAction === null || onSearchAction === void 0 ? void 0 : onSearchAction.onUpdateCriteria) === null || _a === void 0 ? void 0 : _a.call(onSearchAction, criteria, options)) !== null && _b !== void 0 ? _b : { criteria: criteria, options: options };
            dispatch({ type: "UPDATE_CRITERIA", payload: payload });
        },
        clearCriteria: function () { return dispatch({ type: "CLEAR_CRITERIA" }); },
        setFavorites: function (payload) { return dispatch({ type: "SET_FAVORITES", payload: payload }); },
        setAlerted: function (payload) { return dispatch({ type: "SET_ALERTED", payload: payload }); },
        setShowAlertedFirst: function (payload) { return dispatch({ type: "SET_SHOW_ALERTED_FIRST", payload: payload }); },
        setPageNumber: function (pageNumber, options) {
            return dispatch({ type: "SET_PAGE_NUMBER", payload: { pageNumber: pageNumber, options: options } });
        },
        setPageSize: function (payload) { return dispatch({ type: "SET_PAGE_SIZE", payload: payload }); },
        setSearchMode: function (payload) { return dispatch({ type: "SET_SEARCH_MODE", payload: payload }); },
    }); }, [dispatch, onSearchAction]);
};
//# sourceMappingURL=use-search-actions.js.map